<style lang="scss">
.hamburger-button {
    width: 32px;
    height: 18px;
    overflow: hidden;
    flex-flow: column;
    justify-content: space-between;
    margin: auto 0 auto 0;
    transition: height 0.2s;
    z-index: 2;

    span {
        @apply bg-black text-black;
        height: 2px;
        width: 30px;
        border-radius: 1px;
        display: flex;
        transition: all 0.2s;
        transform-origin: left;
        align-self: flex-end;
    }

    &.active {
        height: 23px;
        background: none;
        span {
            @apply bg-black;

            &:nth-child(1) {
                transform: translateX(2px) rotate(45deg);
            }
            &:nth-child(2) {
                opacity: 0;
            }
            &:nth-child(3) {
                transform: translateX(2px) rotate(-45deg);
            }
        }
    }
}
</style>

<template>
    <div class="flex hamburger-button lg:hidden" :class="{'active': active}" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: false
        }
    },

    methods: {
        toggleMenu: function () {
            this.active = !this.active;
            this.$root.navigationIsVisble = this.active;
        }
    }
}
</script>